import {BaseUserFlow, UserFlowList, UserFlowStep} from './BaseUserFlow';
import {UserFlowType} from './UserFlowFacade';

export class ChangeUserFlow extends BaseUserFlow {
  /**
   * @inheritdoc
   */
  public setCurrentStep = (newStep: string) => {
    // Setting the current step will override the steps available so only
    // the step being set can be selected.
    this.setSteps([newStep]);
    this.setStep(0);
    return this;
  };

  /**
   * @inheritdoc
   */
  public configure(): UserFlowList {
    super.configure();
    // const newSteps = [UserFlowStep.Placeholder];
    const newSteps: UserFlowList = [];

    newSteps.push(`${UserFlowType.Change}.${UserFlowStep.Change}`);

    return newSteps;
  }
}
